import { render, staticRenderFns } from "./KpiLayoutContainer.vue?vue&type=template&id=35484a41&scoped=true&"
import script from "./KpiLayoutContainer.vue?vue&type=script&lang=js&"
export * from "./KpiLayoutContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35484a41",
  null
  
)

export default component.exports